module.exports = "https://static.wmbcdn.com/uniweb/images/16794e15ee793fb6d2a9515925b7fd44.svg";